<app-header [showToggle]="false" [showSignin]="false"></app-header>
<main id="main" class="main">

  <section class="section faq">
    <div class="pagetitle text-center">
      <h1>Frequently Asked Questions</h1>
      <div class="div-page-description">
        <h5>
          Discover answers to frequently asked questions and learn how Rank Ahead works.
        </h5>
      </div>
    </div>
    <div class="container overflow-auto pt-0">
      <div class="accordion accordion-flush" id="faq-group-1">

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" data-bs-target="#faqs-1" type="button" data-bs-toggle="collapse" aria-expanded="false">
              What is Page Indexing?
            </button>
          </h2>
          <div id="faqs-1" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
            <div class="accordion-body">
              Page indexing refers to the process where search engines like Google analyze and add web pages to their database, making them eligible to appear in search results. It's a crucial step for ensuring your content is discoverable by users through search engine queries.
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" data-bs-target="#faqs-2" type="button" data-bs-toggle="collapse" aria-expanded="false">
              How long does it take for Google to index a page?
            </button>
          </h2>
          <div id="faqs-2" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
            <div class="accordion-body">
              The time it takes for Google to index a page can vary widely. Typically, it may take anywhere from a <b>few days to a few weeks</b>.
              However, there is no fixed timeframe, as it depends on various factors such as the website's authority, content quality, and how often Google crawls the site.
              <p>
                Utilizing sitemaps, submitting the page to Google Search Console, and creating high-quality, relevant content can expedite the indexing process.
                By indexing pages with <a [routerLink]="'/'">Rank Ahead</a> you might see the results under <b>48 hours</b>.
              </p>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" data-bs-target="#faqs-3" type="button" data-bs-toggle="collapse" aria-expanded="false">
              How does Rank Ahead index pages faster?
            </button>
          </h2>
          <div id="faqs-3" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
            <div class="accordion-body">
              We use official Google Indexing API to get faster indexing results.
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" data-bs-target="#faqs-4" type="button" data-bs-toggle="collapse" aria-expanded="false">
              Why is Owner permission necessary?
            </button>
          </h2>
          <div id="faqs-4" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
            <div class="accordion-body">
              Google requires this strict rule to allow Rank Ahead to act on behalf of your website and effectively submit pages for indexing. Only Owner permissions allow the service account to perform its tasks effectively; any other permission level is insufficient.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" data-bs-target="#faqs-5" type="button" data-bs-toggle="collapse" aria-expanded="false">
              How can I cancel or upgrade my subscription?
            </button>
          </h2>
          <div id="faqs-5" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
            <div class="accordion-body">
              Go to the account settings by clicking <a [routerLink]="['/account-settings']">here</a> and then click the "Manage Subscription" button. On the subsequent page, you can either cancel or upgrade your subscription.
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
